import { render } from "./job-tiny.vue?vue&type=template&id=b669b24a"
import script from "./job-tiny.vue?vue&type=script&lang=js"
export * from "./job-tiny.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__